import React, { forwardRef, memo } from 'react'

const CheckBadgeIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="36.4"
      height="36.4"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
      fill="none"
      stroke="#78BE20"
      strokeWidth={3.227}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}>
      <path d="M11.062 40.938c-1.868-1.868-.629-5.795-1.58-8.094C8.495 30.469 4.875 28.539 4.875 26s3.62-4.469 4.607-6.844c.951-2.297-.288-6.226 1.58-8.094s5.797-.63 8.095-1.581C21.541 8.495 23.461 4.875 26 4.875s4.469 3.62 6.844 4.607c2.299.951 6.225-.288 8.094 1.58 1.869 1.869.63 5.797 1.581 8.095.987 2.385 4.607 4.305 4.607 6.844s-3.62 4.469-4.607 6.844c-.951 2.299.288 6.225-1.581 8.094-1.869 1.869-5.795.63-8.094 1.581C30.469 43.505 28.539 47.125 26 47.125s-4.469-3.62-6.844-4.607c-2.297-.951-6.226.288-8.094-1.58Z" />
      <path d="m17.875 27.625 4.875 4.875L34.125 21.125" />
    </svg>
  )
)

CheckBadgeIcon.displayName = 'CheckBadgeIcon'
export default memo(CheckBadgeIcon)
